import qrCode from "@/assets/guestfriend-qr.png";
import { useLanguage } from "@/i18n/LanguageContext";
import { useCmsContent } from "@/hooks/useCmsContent";

const GUESTFRIEND_LINK = "https://portal.gastfreund.net/esos-hotel-quelle";

const GuestfriendBanner = () => {
  const { t } = useLanguage();
  const { get } = useCmsContent();
  return (
    <section className="w-full bg-primary py-8 md:py-12">
      <div className="hotel-container">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
          <div className="flex-1">
            <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-light text-primary-foreground leading-snug mb-3">
              {get("guestfriend_heading") || t.guestfriend.heading}
              <br className="hidden md:block" /> {get("guestfriend_heading2") || t.guestfriend.heading2}
            </h2>
            <p className="font-body text-sm text-primary-foreground/70">
              {get("guestfriend_partner") || t.guestfriend.partner}{" "}
              <span className="font-semibold text-primary-foreground uppercase tracking-wider">Guestfriend</span>
            </p>
          </div>
          <a href={GUESTFRIEND_LINK} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-2 group shrink-0 md:items-end">
            <div className="bg-white p-2 rounded-md shadow-medium group-hover:shadow-elevated transition-shadow">
              <img src={qrCode} alt="QR Code" loading="lazy" className="w-20 h-20 md:w-24 md:h-24" />
            </div>
            <span className="font-body text-xs text-primary-foreground/80 uppercase tracking-[0.15em] font-semibold group-hover:text-primary-foreground transition-colors">
              {get("guestfriend_scan") || t.guestfriend.scan}
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default GuestfriendBanner;
